<template>
<div class="content">
	<!-- Content Header (Page header) -->
	<section class="content-header">
		<div class="container-fluid">
				<div class="page-header clearfix">
				<h1>{{ $t($route.name) }}</h1>
				<div class="pull-right">
					<router-link data-toggle="tooltip" title="Добави" class="btn btn-success" to="/material/new"><i class="fa fa-plus"></i></router-link>
				</div>
			</div>
		</div>
	</section>
	<!-- Main Content -->
	<div class="container-fluid" v-if="dataReady">

		<div class="card">
			<div class="card-block">
				<div class="row">
					<div class="col-sm-6">
						<div class="md-form form-sm">
							<i class="fa fa-tag prefix"></i>
							<f-category v-model="filter.categories" @input="fetchData()" cplaceholder="Търсене по категория"></f-category>
						</div>
					</div>
					<div class="col-sm-6">
						<div class="md-form form-sm">
							<i class="fa fa-search prefix"></i>
							<input type="text" v-model="search" @keyup.enter="fetchData()" class="form-control" placeholder="Търсене по заглавие, връзка, описание">
						</div>
					</div>
				</div>
				<table class="table table-striped table-no-bordered table-hover table-responsive" cellspacing="0" width="100%" style="width: 100%;">
					<thead>
						<tr>
							<th class="sorting_asc" tabindex="0" style="width: 143px;">Заглавие</th>
							<th class="sorting" tabindex="0" style="width: 215px;">Описание</th>
							<th class="sorting" tabindex="0" style="width: 10px;">Семейства</th>
							<th class="disabled-sorting text-right sorting" tabindex="0" style="width: 102px;">Действия</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="item in records.items" role="row">
							<td tabindex="0" class="sorting_1">
								<router-link :to="'/material/' + item.id" class="text-primary">
									<!--<img :src="item.image || '/network/static/img/default.jpg'" style="width:40px; float:left; margin: 5px;">-->
									{{ item.title }}
								</router-link><br>
								<c-categories :value="item.categories"></c-categories>
							</td>
							<td class="text-truncate" style="max-width: 300px">{{ item.description }}</td>
							<td>
								<c-avatar v-for="family in item.families" :family="family" class="float-left"></c-avatar>
							</td>
							<td class="text-right pr-3">
								<a :href="item.link" class="btn btn-small btn-primary btn-icon" target="_blank"><i class="fa fa-file-text"></i></a>
								<template v-if="canEdit(item)">
									<router-link :to="'/material/' + item.id + '/edit'" class="btn btn-small btn-warning btn-icon"><i class="fa fa-edit"></i></router-link>
									<button type="button" @click="remove(item.id)" class="btn btn-small btn-danger btn-icon m-0"><i class="fa fa-remove"></i></button>
								</template>
							</td>
						</tr>
					</tbody>
				</table>
				<div class="row">
					<div class="col-sm-12">
						<f-pager :total="records.total" :clickhandler="pageClick"></f-pager>
					</div>
				</div>
			</div>
		</div><!--	end card	-->

	</div>
</div>
</template>

<script>

module.exports = {
	data: function () {
		return {
			dataReady: false,
			records: [],
			search: '',
			filter: {
				categories: ''
			},
			page: 1
		};
	},
	created: function () {
		this.fetchData();
	},
	watch: {
		$route: 'fetchData'
	},
	methods: {
		fetchData: function () {
			var query = []; // From https://stackoverflow.com/a/1714899
			for (var key in this.filter) {
				if (this.filter[key]) {
					query.push(encodeURIComponent(key) + '=' + encodeURIComponent(this.filter[key]));
				}
			}
			if (this.search) {
				query.push('search=' + encodeURIComponent(this.search));
			}
			query.push('page=' + this.page);
			query.push('limit=' + this.$config.rpp);
			this.$http.get('backend://material?' + query.join('&')).then((result) => {
				this.records = result.body;
				this.dataReady = true;
			}).catch(this.$http.toastCatcher);
		},
		remove: function (id) {
			if (!confirm('Сигурни ли сте че искате да изтриете този ресурс?')) {
				return;
			}
			this.$http.delete('backend://material/' + id).then((response) => {
				this.fetchData();
			}).catch(this.$http.toastCatcher);
		},
		canEdit: function (material) {
			for (var i = 0; i < material.families.length; i++) {
				if (material.families[i].id + '' === this.$user.familyUser.family.id + '') {
					return true;
				}
			}
			return false;
		},
		pageClick: function (page) {
			this.page = page;
			this.fetchData();
		}
	}
};

</script>
<style>

</style>



// WEBPACK FOOTER //
// Materials.vue?7db081d8